import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Sayfanın en üstüne scroll yap
    window.scrollTo(0, 0);
  }, [pathname]); // pathname değiştiğinde çalış

  return null; // Bu component hiçbir şey render etmez
};

export default ScrollToTop;
